import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import ServiceConfirmationModal from "components/menu/schedule/modal-service-confirmation";
import { openCustomModal, closeCustomModal } from "components/custom/modals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserTypes from "components/auth/user-types";
import {
    requestPostServiceConfirmation,
    requestPutServiceConfirmation,
    requestDeleteServiceConfirmation
} from "api/menu/schedule/actions";

class ServiceConfirmationCell extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);
        this.state = {
            serviceConfirmation: this.props.original.serviceConfirmation,
        };
        this.showModal = this.showModal.bind(this);
    }

    showModal = () => {
        const { auth } = this.props;
        const isMerchandiser = auth.user.role.includes(UserTypes.merchandiser);
        if (isMerchandiser) {
            const modalObj = {
                header: "Service Confirmation",
                modalSettings: {
                    size: "sm",
                },
                children: (
                    <ServiceConfirmationModal
                        handleDelete={() => {
                            this.handleDelete();
                            this.props.closeCustomModal(modalObj);
                        }}
                        handleSave={(data) => {
                            this.handleSave(data);
                            this.props.closeCustomModal(modalObj);
                        }}
                        handleCancel={() => this.props.closeCustomModal(modalObj)}
                        original={this.props.original}
                        serviceConfirmation={this.state.serviceConfirmation}
                    />
                ),
                handleClose: () => this.props.closeCustomModal(modalObj)
            };
            this.props.openCustomModal(modalObj);
        }
    };

    handleSave = (data) => {
        const estimatedDate = { estimatedDate: data };
        const { serviceId } = this.props.original;
        if (this.state.serviceConfirmation) {
            this.props.requestPutServiceConfirmation(serviceId, estimatedDate, response => {
                this.setState({
                    serviceConfirmation: response.data,
                });
            });
        } else {
            this.props.requestPostServiceConfirmation(serviceId, estimatedDate, response => {
                this.setState({
                    serviceConfirmation: response.data,
                });
            });
        }
    };

    handleDelete = () => {
        if (this.state.serviceConfirmation) {
            this.props.requestDeleteServiceConfirmation(this.props.original.serviceId, response => {
                this.setState({
                    serviceConfirmation: null,
                });
            });
        }
    };

    render() {
        const { serviceConfirmation } = this.state;
        const { auth } = this.props;
        const isMerchandiser = auth.user.role.includes(UserTypes.merchandiser);

        if (serviceConfirmation && serviceConfirmation.estimatedDate !== null) {
            return (
                <div className={`${isMerchandiser && "g-pointer"} p-0 w-100`} onClick={this.showModal}>
                    {moment(serviceConfirmation.estimatedDate).format(this.dateFormat)}
                    <FontAwesomeIcon className="text-success h5 m-0 float-right" icon="check-circle" />
                </div>
            );
        } else if (serviceConfirmation) {
            return (
                <div className={`${isMerchandiser && "g-pointer"} p-0 w-100`} onClick={this.showModal}>
                    No Date
                    <FontAwesomeIcon className="text-warning h5 m-0 float-right" icon={["far", "check-circle"]} />
                </div>
            );
        } else {
            return (
                <div className={`${isMerchandiser && "g-pointer"} p-0 w-100`} onClick={this.showModal}>
                    To be Confirmed
                    <FontAwesomeIcon className="text-danger h5 m-0 float-right" icon="question-circle" />
                </div>
            );
        }
    }
}

ServiceConfirmationCell.propTypes = {
    requestPostServiceConfirmation: PropTypes.func.isRequired,
    requestPutServiceConfirmation: PropTypes.func.isRequired,
    requestDeleteServiceConfirmation: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
    requestPostServiceConfirmation: bindActionCreators(requestPostServiceConfirmation, dispatch),
    requestPutServiceConfirmation: bindActionCreators(requestPutServiceConfirmation, dispatch),
    requestDeleteServiceConfirmation:
        bindActionCreators(requestDeleteServiceConfirmation, dispatch),
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ServiceConfirmationCell);
